<form class="form-container center-screen" [formGroup]="riskScoresForm">
  <table class="table table-striped table-hover table-sm shadow-2-strong rounded-1 p-1" [style.width.px]="600">
    <caption>Search</caption>
    <tbody class="field-4column-label">
      <tr>
        <td class="py-2">Parameter Type</td>
        <td>
          <div class="input-group">
            <mdb-select class="select table-control has-cell-control" formControlName="parameterType" [(ngModel)]="riskScoreModel.parameterType"
              style="max-width: 200px;"
              (change)="findByParameterType(riskScoreModel.parameterType)">
              <mdb-option *ngFor="let parameterType of lstParemeterType" [value]="parameterType.value">
                {{parameterType.description}}
              </mdb-option>
            </mdb-select>
            <button class="btn btn-primary" mdbRipple (click)="findAll()"> Show All </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <lms-table-wrapper [config]="config">
    <table class="table table-striped table-hover table-sm shadow-2-strong rounded-1 p-1" [style.width.px]="650">
      <caption>Scorecard</caption>
      <thead>
        <tr>
          <th>Parameter Type</th>
          <th>Description</th>
          <th>Score</th>
          <th style="width: 30px;">Edit </th>
          <th style="width: 30px;">Delete </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let score of items | paginate: config">
          <td>{{score.parameterType}}</td>
          <td>{{score.description}}</td>
          <td align="center" style="font-weight: 600;">{{score.score}}</td>
          <td align="center">
            <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple (click)="editRiskScore(score)">
              <i class="fas fa-xs fa-fw fa-pencil"></i>
            </button>
          </td>
          <td align="center">
            <!--removeScorecard(score.id);-->
            <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple (click)="removeRiskScore(score)">
              <i class="fas fa-xs fa-fw fa-trash-can"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </lms-table-wrapper>

  <div class="center-screen m-1 p-1">
    <button class="btn btn-primary btn-sm " mdbRipple (click)="addRiskScore()">
      Add a new risk score
    </button>
  </div>
</form>
